module.exports = __webpack_public_path__ + "268ea437a08f70d3a409ddb1405b9de6.svg";